
const base = (website) => {
  const portfolio = website.portfolio.map(item => {
    if (item.show) {
      return ({
        category: item.category.replace(/ /g,'').toLowerCase(),
        heading: item.title,
        subHeading: item.category,
        url: item.downloadURL,
      })
    }
  });

  return portfolio;
};

export const PortfolioFactory = {
  getBase: base,
};



// WEBPACK FOOTER //
// ./src/store/generators/websiteTemplates/factories/PortfolioFactory.js